(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reducedMotion.matches) {
    return;
  }

  var mainSelector = '#MainContent';
  var revealSelectors = [
    '.shopify-section > :not(script):not(style)',
    '.shopify-section h1',
    '.shopify-section h2',
    '.shopify-section h3',
    '.shopify-section .section-heading',
    '.shopify-section [class*="title"]',
    '.shopify-section [class*="image"]',
    '.shopify-section [class*="media"]',
    '.shopify-section [class*="card"]',
    '.shopify-section [class*="product"]',
    '.shopify-section [class*="testimonial"]',
    '.shopify-section [class*="stat"]'
  ];

  var skipSelectors = [
    'script',
    'style',
    'noscript',
    'svg',
    'form',
    'input',
    'select',
    'textarea',
    '[class*="header"]',
    '[class*="footer"]',
    '[class*="mega"]',
    '[class*="menu"]',
    '[class*="nav"]',
    '[class*="search"]',
    '[class*="cart"]',
    '[data-no-reveal]'
  ];

  function shouldSkip(element) {
    return skipSelectors.some(function (selector) {
      return element.matches(selector) || element.closest(selector);
    });
  }

  function prepareReveals(root) {
    var main = document.querySelector(mainSelector);
    var scope = root || main;

    if (!main || !scope) {
      return [];
    }

    if (scope !== main && !main.contains(scope)) {
      return [];
    }

    var elements = Array.prototype.slice.call(scope.querySelectorAll(revealSelectors.join(',')));
    var revealIndex = 0;

    elements.forEach(function (element) {
      if (shouldSkip(element) || element.classList.contains('gacket-reveal')) {
        return;
      }

      element.classList.add('gacket-reveal');

      if (element.matches('p, [class*="text"], [class*="copy"], [class*="description"]')) {
        element.classList.add('gacket-reveal--soft');
      }

      element.style.setProperty('--reveal-delay', Math.min((revealIndex % 5) * 85, 340) + 'ms');
      revealIndex += 1;
    });

    return elements.filter(function (element) {
      return element.classList.contains('gacket-reveal') && !element.classList.contains('is-visible');
    });
  }

  function revealWithObserver(elements) {
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.1
    });

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function initAnimations() {
    document.documentElement.classList.add('js-animate-ready');
    revealWithObserver(prepareReveals(document));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }

  document.addEventListener('shopify:section:load', function (event) {
    revealWithObserver(prepareReveals(event.target));
  });
})();
